/* =====================================================================
   GRT WALQEN - Discount banner modal (standalone)
   ===================================================================== */
(function () {
  "use strict";

  function qsa(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  function now() {
    return Date.now ? Date.now() : new Date().getTime();
  }

  function canShow(storageKey) {
    if (!storageKey) return true;
    try {
      var until = Number(window.localStorage.getItem(storageKey));
      return !until || now() > until;
    } catch (e) {
      return true;
    }
  }

  function rememberDismissal(storageKey, hideDays) {
    if (!storageKey || hideDays <= 0) return;
    try {
      window.localStorage.setItem(storageKey, String(now() + hideDays * 24 * 60 * 60 * 1000));
    } catch (e) {}
  }

  function initModal(root) {
    var delaySeconds = Number(root.getAttribute("data-delay")) || 4;
    var hideDays = Number(root.getAttribute("data-hide-days")) || 0;
    var storageKey = root.getAttribute("data-storage-key") || "";
    var closeBtn = root.querySelector("[data-discount-banner-close]");
    var copyBtn = root.querySelector("[data-discount-banner-copy]");
    var visibleClass = "is-visible";
    var bodyClass = "wq-discount-modal-open";
    var revealTimer;

    if (!canShow(storageKey)) return;

    function closeModal(remember) {
      window.clearTimeout(revealTimer);
      root.classList.remove(visibleClass);
      root.setAttribute("aria-hidden", "true");
      document.body.classList.remove(bodyClass);
      document.removeEventListener("keydown", onKeydown);
      if (remember) rememberDismissal(storageKey, hideDays);
    }

    function onKeydown(e) {
      if (e.key === "Escape") closeModal(true);
    }

    function openModal() {
      if (!canShow(storageKey)) return;
      root.classList.add(visibleClass);
      root.setAttribute("aria-hidden", "false");
      document.body.classList.add(bodyClass);
      document.addEventListener("keydown", onKeydown);
      window.setTimeout(function () {
        if (closeBtn) closeBtn.focus();
      }, 250);
    }

    if (closeBtn) {
      closeBtn.addEventListener("click", function () {
        closeModal(true);
      });
    }

    root.addEventListener("click", function (e) {
      if (e.target === root) closeModal(true);
    });

    if (copyBtn) {
      copyBtn.addEventListener("click", function () {
        var code = copyBtn.getAttribute("data-code") || "";
        var originalLabel = copyBtn.getAttribute("data-copy-label") || copyBtn.textContent;
        var copiedLabel = copyBtn.getAttribute("data-copied-label") || "Copied";

        function markCopied() {
          copyBtn.textContent = copiedLabel;
          window.setTimeout(function () {
            copyBtn.textContent = originalLabel;
          }, 1800);
        }

        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(code).then(markCopied).catch(markCopied);
        } else {
          markCopied();
        }
      });
    }

    revealTimer = window.setTimeout(openModal, delaySeconds * 1000);
  }

  function init() {
    qsa("[data-discount-banner-modal]").forEach(initModal);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
